app.components.image_text_box = {
    onReady: function () {
        if ($('.image-text-box').length) {
            return true;
        }
    },
    addListener: async function () {
        const imageTextBoxes = document.querySelectorAll('.image-text-box');

        imageTextBoxes.forEach(imageTextBox => {
            const toggle = imageTextBox.querySelector('.accordion-header');

            if (toggle) {
                toggle.setAttribute('aria-expanded', 'false');

                toggle.addEventListener('click', function () {
                    imageTextBoxes.forEach(box => {
                        const otherToggle = box.querySelector('i.icon-chevron-down');

                        if (box !== imageTextBox) {
                            box.classList.remove('open');
                            if (otherToggle) {
                                otherToggle.setAttribute('aria-expanded', 'false');
                            }
                        }
                    });

                    const isExpanded = imageTextBox.classList.toggle('open');
                    toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
                });
            }
        });
    }
};
